import React, { useEffect, useState } from "react";
import Banner from "../banner/banner";
// import CrewSlider from "../crewSlider/crewSlider";
import "../landscapeSlider/landscapeSlider.css";
import "../portraitSlider/portraitSlider.css";
import DetailsTab from "../detailsTab/detailsTab";
import { getTicker, getFullPageItem, getAWSUrl } from "../api/core";
import NotFound from "../notfound/notfound";
import Ticker from "../Ticker/ticker";
import Head from "../head/head";
import CarouselContentLoader from "../loader/contentLoader";

const Season = (props) => {
  const [seasonVal, setSeasonVal] = useState([]);
  const [seasonItem, setSeasonItem] = useState([]);
  const [tickStatus, SetTickStatus] = useState("");
  const [tick, setTick] = useState([]);
  const [seasonImage, setSeasonImage] = useState("");
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [web, SetWeb] = useState(true);
  useEffect(() => {
    const FullPageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullPageItem(app, id, 0, 10).then(
        (result) => {
          getTickerDetail(app, id);
          setSeasonVal(result.data);
          setSeasonItem(result.data.items);
          setSeasonImage(
            result.data.bannerImage ? result.data.bannerImage.imagekey : ""
          );
          SetWeb(result.data.devices[0].itemVisibility);
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const getTickerDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getTicker(app, id).then(
        (result) => {
          setTick(result.data);
          SetTickStatus(result.status);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    FullPageDetail(props.match.params.AppId, props.match.params.videoId);
    isLoading(false);
  }, [props.match.params.videoId, props.match.params.AppId]);

  if (!loading && !error && web) {
    return (
      <div>
        <Head
          title={seasonVal.displayName}
          quote={seasonVal.displayName}
          description={seasonVal.description}
          image={
            seasonVal.bannerImage !== null
              ? getAWSUrl() + seasonVal.bannerImage.imagekey
              : ""
          }
        ></Head>
        <Banner data={seasonVal} image={seasonImage} {...props}></Banner>

        <DetailsTab
          idet={"related"}
          type={"season"}
          active={"episodes"}
          data={seasonItem}
          detail={seasonVal}
          id={seasonVal.recommendation}
          track={seasonVal.recommendation}
          ally={false}
          {...props}
        ></DetailsTab>
        {tickStatus.toString() === "200" && tick != null ? (
          <Ticker id={"ticker" + 20} tickData={tick}></Ticker>
        ) : (
          ""
        )}

        {/* <CrewSlider title={"Cast and Crew"} image={true} id={"castid"}></CrewSlider> */}
      </div>
    );
  } else {
    if (!web) {
      return (
        <div style={{ minHeight: "500px" }}>
          <NotFound
            code={"Hidden Page"}
            message={"This Page is Hidden in thw Website"}
          ></NotFound>
        </div>
      );
    } else if (loading) {
      return (
        <div style={{ minHeight: "400px" }}>
          <CarouselContentLoader />
        </div>
      );
    } else {
      return <div style={{ minHeight: "400px" }}></div>;
    }
  }
};

export default Season;
